<template>
  <div class="min-h-screen flex items-center justify-center px-6 py-16 bg-gray-50">
    <div class="w-full max-w-md text-center">
      <img src="/salestial-logo.png" alt="Salestial" class="w-14 h-14 mx-auto mb-5 drop-shadow" />

      <p class="text-[13px] font-bold tracking-widest text-sky-600">{{ error?.statusCode ?? 500 }}</p>
      <h1 class="text-2xl font-extrabold text-gray-900 mt-1">{{ judul }}</h1>
      <p class="text-sm text-gray-500 mt-2 leading-relaxed">{{ pesan }}</p>

      <div class="flex items-center justify-center gap-2 mt-7">
        <NuxtLink
          to="/dashboard"
          class="px-4 py-2.5 rounded-lg bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold shadow-md shadow-sky-600/25"
        >
          Ke Dashboard
        </NuxtLink>
        <button
          type="button"
          class="px-4 py-2.5 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 text-sm font-semibold"
          @click="clearError({ redirect: '/dashboard' })"
        >
          Coba lagi
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

/**
 * Halaman error bermerek Salestial.
 *
 * Tanpa file ini Nuxt memakai halaman error bawaannya — judul tab-nya berbunyi
 * "… | Nuxt" dan isinya membawa branding Nuxt, jadi terlihat seperti keluar dari
 * aplikasi. Sengaja berdiri sendiri (tidak memakai layout `default`): layout itu
 * butuh sesi & data akses, yang belum tentu ada saat error terjadi.
 */
const props = defineProps<{ error?: NuxtError }>()

const judul = computed(() => {
  const kode = props.error?.statusCode
  if (kode === 404) return 'Halaman tidak ditemukan'
  if (kode === 403) return 'Akses ditolak'
  if (kode === 401) return 'Sesi berakhir'
  return 'Terjadi kesalahan'
})

const pesan = computed(() => {
  const kode = props.error?.statusCode
  if (kode === 404) return 'Alamatnya tidak ada di Salestial Dashboard. Mungkin salah tulis, atau halamannya sudah dipindah.'
  if (kode === 403) return 'Akun Anda tidak punya akses ke halaman ini. Hubungi admin kalau memang perlu.'
  if (kode === 401) return 'Silakan masuk kembali untuk melanjutkan.'
  return String(props.error?.message || 'Sesuatu gagal di sisi server. Coba lagi sebentar.')
})

useHead({
  title: computed(() => `${judul.value} — Salestial Dashboard`),
  link: [
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32.png' },
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico?v=salestial' },
  ],
})
</script>
